var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},_vm._l((_vm.data),function(item){return _c('v-btn',{staticClass:"elevation-0 ms-1",class:{
            'v-btn--active': _vm.reactiveData.selectedItems.includes(item),
          },on:{"click":function () { return _vm.itemClicked(item); }}},[_c('small',[_vm._v(_vm._s(item.name))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }